import { render } from "./bottom-nav.component.vue?vue&type=template&id=370e8bb9&ts=true"
import script from "./bottom-nav.component.vue?vue&type=script&lang=ts"
export * from "./bottom-nav.component.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__